import { useCallback } from 'react';
import { store } from '@src/app/store';
import { StatelessWidgetsMap } from '@src/types/core_t';

/**
 * Non-reactive hook that provides a getter function to access the widgets map
 * without causing re-renders when the map changes.
 * 
 * This is useful when you need to access the current widgets map in event handlers
 * or other scenarios where you don't want to subscribe to changes.
 * 
 * @returns A function that returns the current widgets map
 */
const useGetWidgetsMap = (): () => StatelessWidgetsMap => {
  const getWidgetsMap = useCallback((): StatelessWidgetsMap => {
    const state = store.getState();
    return state.logicMapper.gates;
  }, []);

  return getWidgetsMap;
};

export default useGetWidgetsMap;